import { Calculator, Hand, Grid3x3, Heart, ScrollText } from "lucide-react";

export const TOOLS = [
  {
    slug: "numerology-calculator",
    name: "Numerology Calculator",
    icon: Calculator,
    tagline: "Your complete number blueprint",
    description: "Enter your name and birth date to reveal your Mulank, Bhagyank, lucky elements, personality, career, love and health guidance.",
    image: "https://images.unsplash.com/photo-1502570149819-b2260483d302?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    featured: true,
  },
  {
    slug: "palm-reading",
    name: "AI Palm Reading",
    icon: Hand,
    tagline: "Upload a palm, meet the lines",
    description: "Our AI reads your life, heart, head, fate, marriage, sun and health lines to share warm, practical insights.",
    image: "https://images.unsplash.com/photo-1696185738970-d61d520ca4aa?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    slug: "lo-shu-grid",
    name: "Lo Shu Grid",
    icon: Grid3x3,
    tagline: "Map your missing energies",
    description: "Generate your 3×3 Lo Shu grid, find missing and strong numbers, and learn simple ways to restore balance.",
    image: "https://images.unsplash.com/photo-1740062450744-2e295c2512fc?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    slug: "love-calculator",
    name: "Love Calculator",
    icon: Heart,
    tagline: "A playful compatibility spark",
    description: "Enter two names for a fun compatibility score and a warm message to share. For entertainment only.",
    image: "https://images.unsplash.com/photo-1590591398843-b526d7b43838?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    slug: "numerology-report",
    name: "Personalized Report",
    icon: ScrollText,
    tagline: "Your full life reading, printable",
    description: "A complete AI-crafted numerology report with remedies, life challenges and a 7-day action plan you can download.",
    image: "https://images.unsplash.com/photo-1590591398843-b526d7b43838?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
];
